import ceoMessage from "./notice-contents/ceo-message";
import ethicsCode from "./notice-contents/ethics-code";
import environmentalPolicy from "./notice-contents/environmental-policy";
import officeRelocation from "./notice-contents/office-relocation";
import seoulSmeWorklife from "./notice-contents/seoul-sme-worklife";

export default [
  {
    id: 6,
    title:
      "이모션글로벌, ‘서울형 강소기업’·‘서울시 중소기업 워라밸 포인트 기업’ 선정",
    date: "2026.09.16",
    content: seoulSmeWorklife(
      require("@/assets/images/notice/new-emotion-logo.png")
    )
  },
  {
    id: 4,
    title: "이모션글로벌 사무실 이전 안내",
    date: "2026.06.16",
    content: officeRelocation(require("@/assets/images/notice/address.png"))
  },
  {
    id: 1,
    title: "자본금 감소 공고",
    date: "2025.06.24",
    content:
      "주식회사 이모션글로벌의 자본금 감소에 관한 공고입니다. 자세한 내용은 아래 첨부파일을 확인해 주세요.",
    file: "https://www.emotion.co.kr/download/Emotionglobal_CapitalReductionNotice_250624.pdf"
  },
  {
    id: 5,
    title: "환경경영정책",
    date: "2024.12.09",
    content: environmentalPolicy
  },
  {
    id: 2,
    title: "윤리강령",
    date: "2024.12.09",
    content: ethicsCode
  },
  {
    id: 3,
    title: "CEO 메시지",
    date: "2024.12.09",
    content: ceoMessage,
    signature: require("@/assets/images/notice/notice-ceo-signature.png")
  }
];
